import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import EmbeddedApp from '../OS/EmbeddedApp';
import '../OS/index.css';
import { useAuth } from '@/contexts/AuthContext';

import { disableModelCacheApi } from "../OS/lib/disableModelCacheApi";
import { clearCachesOnce } from "../OS/lib/clearCachesOnce";

//disableModelCacheApi();
clearCachesOnce();

const COLLAPSED_WIDTH = 56;
const EXPANDED_WIDTH = 240;

const MapleOSStart: React.FC = () => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [pinned, setPinned] = React.useState<boolean>(() => {
    const saved = localStorage.getItem('MapleOS-menu-pinned');
    return saved === 'true';
  });

  const handlePinnedChange = (next: boolean) => {
    setPinned(next);
    localStorage.setItem('MapleOS-menu-pinned', next ? 'true' : 'false');
  };

  const leftOffset = pinned ? EXPANDED_WIDTH : COLLAPSED_WIDTH;

  const contentStyle: React.CSSProperties = {
    marginLeft: leftOffset,
    ["--mapleos-rail-offset" as any]: `${leftOffset}px`,
  };

  const didDispatchRef = React.useRef(false);

  React.useEffect(() => {
    const params = new URLSearchParams(globalThis.location.search);
    const openId = params.get('open');
    const title = params.get('title') || openId || '';
    const route = params.get('route') || undefined;
    const filePath = params.get('filePath') || undefined;
    const fileContent = params.get('fileContent') || undefined;

    console.log('[MapleOSStart] Parsed params', { openId, title, route, filePath, fileContent, href: globalThis.location.href });

    const triggerOpen = (reason: string) => {
      if (!openId) return;
      if (didDispatchRef.current) {
        console.log('[MapleOSStart] Skipping dispatch (already sent)', { reason });
        return;
      }
      console.log('[MapleOSStart] Dispatching operator:openWindow', { reason, appId: openId, title, route, filePath, fileContent });
      window.dispatchEvent(new CustomEvent('operator:openWindow', { detail: { appId: openId, title, route, filePath, fileContent } }));
      didDispatchRef.current = true;
    };

    if (openId) {
      const onReady = () => {
        console.log('[MapleOSStart] mapleos:ready received — proceeding to open app');
        triggerOpen('mapleos:ready');
        window.removeEventListener('mapleos:ready', onReady as EventListener);
      };
      window.addEventListener('mapleos:ready', onReady as EventListener);

      return () => {
        window.removeEventListener('mapleos:ready', onReady as EventListener);
      };
    } else {
      console.log('[MapleOSStart] No "open" param provided.');
    }
  }, []);

  if (loading) {
    return <div className="h-full w-full overflow-hidden bg-background" />;
  }

  if (!user) {
    return (
      <Navigate
        to="/auth"
        replace
        state={{ from: `${location.pathname}${location.search}${location.hash}` }}
      />
    );
  }

  return (
    <div className="relative h-full w-full overflow-hidden bg-background text-foreground mapleos-root">

        <EmbeddedApp />
      </div>
  );
};

export default MapleOSStart;